import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faTrash } from '@fortawesome/free-solid-svg-icons';
import './UserInput.css';

function UserInput({ onSendMessage, onClearChat, isLoading }) {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);
  const maxHeight = 150; // Max height for auto-expanding textarea

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      if (textareaRef.current.scrollHeight > maxHeight) {
        textareaRef.current.style.height = maxHeight + 'px';
        textareaRef.current.style.overflowY = 'scroll';
      } else {
        textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
        textareaRef.current.style.overflowY = 'hidden';
      }
    }
  };

  const handleChange = (event) => {
    setMessage(event.target.value);
    adjustHeight();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      sendMessage();
    }
  };

  const sendMessage = () => {
    if (message.trim() !== '') {
      onSendMessage(message);
      setMessage('');
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
        textareaRef.current.style.overflowY = 'hidden';
      }
    }
  };

  const handleVoiceInput = () => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Speech recognition is not supported in this browser. Please use Chrome.');
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onstart = () => {
      console.log('Voice recognition started...');
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setMessage((prev) => prev + ' ' + transcript);
      adjustHeight();
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error:', event.error);
      alert('Error using speech recognition. Please try again.');
    };

    recognition.start();
  };

  return (
    <div className="user-input">
      <textarea
        ref={textareaRef}
        value={message}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Type your message here..."
        className="input-field"
        rows="1"
        disabled={isLoading} // Disable input while AI is responding
      />
      <div className="button-group">
        <button onClick={sendMessage} disabled={isLoading}>
          Send
        </button>
        <button onClick={onClearChat} disabled={isLoading}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
        <button onClick={handleVoiceInput} disabled={isLoading}>
          <FontAwesomeIcon icon={faMicrophone} />
        </button>
      </div>
    </div>
  );
}

export default UserInput;